import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_DimensionRow,
    WB_ReportTileDimensionRow,
    WB_ReportTileRow,
    WB_WorkspaceDimensionRow,
    WB_WorkspaceReportDimensionRow,
    WB_WorkspaceReportRow,
    WB_WorkspaceRow
} from "../PA.Core/PAdbSchemaRows";
import {
    esWB_Connection,
    esWB_Dimension,
    esWB_ReportTile,
    esWB_ReportTile_Dimension,
    esWB_SalesOrg,
    esWB_Workspace,
    esWB_Workspace_Dimension,
    esWB_Workspace_Report,
    esWB_Workspace_Report_Dimension
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {
    IHaveDimensions,
    IHaveWorkspaceReports,
    IWorkspace,
    IWorkspaceChangedEvent
} from "../PA.Reporting.Core/PA.Reporting.IF.Aspects";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {
    IConnection,
    IDimensionSelector,
    IDimensionSelectorSet,
    IWorkspaceElement,
    IWorkspaceElementMessage,
    IWorkspaceElementPost,
    IWorkspaceElementSet
} from "../PA.Reporting.Core/PA.Reporting.IF";
import {WorkspaceBOIDimensionSelector} from "./WorkspaceBO.IDimensionSelector";
import {WorkspaceBOIWorkspaceReport} from "./WorkspaceBO.IWorkspaceReport";
import {Subscription} from "rxjs/Subscription";

import {JSONUtils} from "../PA.Core/Basic/JSON";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {PAusrContext} from "../PA.Core/PAusrContext";
import {IApplicationSession} from "../PA.UIM.Core/PA.UIM.Core.IF.Platform";
import {DimensionDataService} from "../PA.Reporting.Services/DimensionDataService";

export interface IWorkspaceLoadOptions {
    dbContext?: PAdbContext
}

export interface IWorkspacePropertyChangedEvent {
    WorkspaceBO: WorkspaceBO,
    Row: WB_WorkspaceRow,
    PropertyChanged: string,
    PropertyValue: any
}

const WorkspaceLoadOptions_default: IWorkspaceLoadOptions = {}

export class WorkspaceBO
    implements IBusinessObject,
        IWorkspace,
        IHaveDimensions,
        IHaveWorkspaceReports,
        IDimensionSelectorSet,
        IWorkspaceElementSet {
    Identity: IdentityProvider;

    CreateOptions: any;
    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Workspace: WB_WorkspaceRow;
    usrContext: PAusrContext;

    applicationSession: IApplicationSession;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;
        else
            this.dbContext = new PAdbContext()

        this.Identity = new IdentityProvider({id: 0, name: 'New Tag'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Workspace = null;
        this.usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

        this.applicationSession = null


        // Initialize non BO state
        this.IWorkspace_init()
        this.IHaveDimensions_init()
        this.IHaveWorkspaceReports_init()
        this.IDimensionSelector_init()
        this.IWorkspaceElementSet_init()

    }

    get WB_Workspace(): WB_WorkspaceRow {
        return this.drWB_Workspace;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Workspace");

        let internalOnComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if ('appSession' in self.LoadOptions)
                self.applicationSession = self.LoadOptions.appSession

            if (this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Workspace.";
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Workspace)
                .then((newWorkspaceRow: WB_WorkspaceRow) => {
                    newWorkspaceRow.setDefaults()
                    newWorkspaceRow.cif.WORKSPACE_NAME = "New Workspace"

                    self.drWB_Workspace = newWorkspaceRow;
                    self.dbContext.add(esWB_Workspace, newWorkspaceRow)
                    self.Identity.setAll(self.WB_Workspace.cif.WB_WORKSPACE_ID, self.WB_Workspace.cif.WORKSPACE_ID, self.WB_Workspace.cif.WORKSPACE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Workspace, 'WB_WORKSPACE_ID', 'WORKSPACE_ID', 'WORKSPACE_NAME')
                    resolve(self);

                }).catch((err) => {
                self.LoadProgressProvider.exception(err)
                error(err)
            })

        });

        self._OnLoadComplete = internalOnComplete

        return new Promise<IBusinessObject>((resolve, error) => {
            internalOnComplete
                .then((BO) => {
                    return self._AfterBoLoadCompleteInternal()
                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()
                resolve(self)
            }).catch((err) => {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
            })
        })

    }

    Load(anId: number | number, options: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        let _OnLoadCompleteInternal = new Promise<WorkspaceBO>((resolve, error) => {

            if (self.bIsLoaded) {
                resolve(self); // "Workspace already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, WorkspaceLoadOptions_default)

            if ('appSession' in options) { // @ts-ignore
                self.applicationSession = options.appSession
            }

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isUndefined(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isUndefined(self.dbContext)) {
                error("Unable to determine dbContext for Workspace.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = WorkspaceBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = WorkspaceBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aWorkspaceRow: any = recordResolver.get(esWB_Workspace, anId)

                    if (_.isEmpty(aWorkspaceRow)) {
                        error("Workspace not Found");
                        return;
                    }

                    self.drWB_Workspace = aWorkspaceRow;
                    self.Identity.setAll(self.WB_Workspace.cif.WB_WORKSPACE_ID, self.WB_Workspace.cif.WORKSPACE_ID, self.WB_Workspace.cif.WORKSPACE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Workspace, 'WB_WORKSPACE_ID', 'WORKSPACE_ID', 'WORKSPACE_NAME')
                    self.WorkspaceElements_onWorkspaceReportsChanged(self)
                    resolve(self)
                }).catch(function (err: any) {
                error(err)
                return;
            });

        });

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            _OnLoadCompleteInternal
                .then((aBO) => {

                    return self._AfterBoLoadCompleteInternal()

                }).then((ignored) => {
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()

                resolve(self)
            }).catch((err) => {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                resolve(self)
            })
        })

        return this._OnLoadComplete;

    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        return new Promise<void>(async (resolve, error) => {
            //var tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('WorkspaceBO.PostLoad', 'Processing Loaded Data');
            await self.OnIHaveDimensionsLoadComplete
            await populateDefaults()
            await self.OnIDimensionsSelector_DimensionsChanged()
            await self._RunAfterCreates_OnBoLoadComplete()

            resolve();

            async function populateDefaults() {
                let selectedKeys: any[] = []
                if (!_.isEmpty(self.applicationSession) && self.WB_Workspace.isActiveNew) {
                    selectedKeys = self.applicationSession.getMRUList()
                }
                let dimRows = _.filter(self.WB_Workspace.WB_WorkspaceDimensionRows, aRow => aRow.cif.DELETED_IND != '1')
                for (let i = 0; i < dimRows.length; i++) {
                    let aWorkspaceDimensionRow = dimRows[i]
                    if (selectedKeys.length) {
                        await self._setDefaultHierarchy(self.WB_Workspace, aWorkspaceDimensionRow, selectedKeys, true)
                    }
                }
            }
        }).catch((err: any) => {
            Error(err);
        });
    }


    private _RunAfterCreates_OnBoLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {

            self._WorkspaceRow_AfterCreate(self.WB_Workspace)
                .then((ignore2) => {

                    let tasks: Promise<any>[] = []

                    return Promise.all(tasks)

                }).then((ignore) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    private _WorkspaceRow_AfterCreate(aWorkspaceRow: WB_WorkspaceRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            // Synchronous part

            // Async part(s)

            // Create Metrics row(s) as needed

            ASync.resolve()
                .then((ignore) => {

                    // Wire up Change Events
                    aWorkspaceRow.setupOnChangeEvents([], self.IWorkspace_onRecordChange.bind(self), self)
                    resolve()
                }).catch((err) => {
                error(err)
            })
        });

    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Workspace.cif.WORKSPACE_NAME + "(" + self.WB_Workspace.cif.WORKSPACE_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Workspace.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_Workspace.cif.WORKSPACE_NAME + "(" + self.WB_Workspace.cif.WORKSPACE_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {

            if (this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Workspace.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            self.IDimensionSelectorSet_BeforeSave()
            self.IWorkspaceElements_BeforeSave()

            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }


            saveFunction(esWB_Workspace, self.drWB_Workspace, {})
                .then((ignored) => {
                    let tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Workspace_Dimension, self.drWB_Workspace.WB_WorkspaceDimensionRows))
                    tasks.push(saveFunction(esWB_Workspace_Report, self.drWB_Workspace.WB_WorkspaceReportRows))

                    _.forEach(self.drWB_Workspace.WB_WorkspaceReportRows, (aWSRRow: WB_WorkspaceReportRow) => {
                        tasks.push(saveFunction(esWB_Workspace_Report_Dimension, aWSRRow.WB_WorkspaceReportDimensionRows))
                    })

                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


    //Delete
    Delete(): Promise<IBusinessObject> {
        return this.DeleteUsing(false)
    }

    DeleteBatch(): Promise<IBusinessObject> {
        return this.DeleteUsing(true)
    }

    private DeleteRows(): void {
        let self = this
        self.WB_Workspace.cif.DELETED_IND = '1'
        self.WB_Workspace.markDeleted()

        _.forEach(self.WB_Workspace.WB_WorkspaceDimensionRows, (wd: WB_WorkspaceDimensionRow) => {
            if (wd.isActive) {
                wd.cif.DELETED_IND = '1'
                wd.markDeleted()
            }
        })

        _.forEach(self.WB_Workspace.WB_WorkspaceReportRows, (wr: WB_WorkspaceReportRow) => {
            wr.cif.DELETED_IND = '1'
            wr.markDeleted()


            _.forEach(wr.WB_WorkspaceReportDimensionRows, (wrd: WB_WorkspaceReportDimensionRow) => {
                wrd.cif.DELETED_IND = '1'
                wrd.markDeleted()

            })

        })

    }

    private DeleteUsing(bBatch: boolean): Promise<IBusinessObject> {
        const self = this;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.Identity.name + "(" + self.Identity.id_ui + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // 1. Validate if we can delete the Workspace


            // 2. Do the Delete
            self.DeleteRows();
            self.SaveUsing(bBatch)
            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
            resolve(self);
        });

    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IWorkspace operations">


    private _WorkspacePropertyChanged: BehaviorSubject<IWorkspaceChangedEvent>;

    private IWorkspace_init(): void {
        this._WorkspacePropertyChanged = new BehaviorSubject<IWorkspaceChangedEvent>(undefined)
    }

    private IWorkspace_onRecordChange(record: WB_WorkspaceRow, propertyName: string, propertyValue: any, options: WorkspaceBO) {
        this.WorkspacePropertyChanged.next({
            WorkspaceBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    get WorkspacePropertyChanged(): BehaviorSubject<IWorkspaceChangedEvent> {
        return this._WorkspacePropertyChanged
    }

    private async _setDefaultHierarchy(mainRow: WB_WorkspaceRow, aWorkspaceDimensionRow: WB_WorkspaceDimensionRow | WB_WorkspaceReportDimensionRow, selectedKeys: any[], bMain: boolean): Promise<void> {
        let self = this
        let dimension: string = ""
        let clip = _.first(selectedKeys)

        if (!_.isEmpty(clip) && !_.isEmpty(clip.wbSalesOrgId)) {
            self.WB_Workspace.WB_SALESORG_ID = Number(clip.wbSalesOrgId)
            self.WB_Workspace.WB_SalesOrgRow = await self.dbContext.find(esWB_SalesOrg, self.WB_Workspace.WB_SALESORG_ID)
        }

        if (bMain) {
            let aWB_Connnection = aWorkspaceDimensionRow.WB_DimensionRow.WB_ConnectionRow
            let aConnection: IConnection = {
                ConnectionId: aWB_Connnection.cif.CONNECTION_ID,
                ConnectionTypeId: aWB_Connnection.cif.CONNECTION_TYPE_ID,
                ConnectionName: aWB_Connnection.cif.CONNECTION_NAME,
                ConnectionOptions: JSONUtils.parse(aWB_Connnection.cif.CONNECTION_OPTIONS, {})
            }
            let aDimension = {
                DimensionId: aWorkspaceDimensionRow.WB_DimensionRow.cif.DIMENSION_ID,
                DimensionName: aWorkspaceDimensionRow.WB_DimensionRow.cif.DIMENSION_NAME,
                DimensionTechnicalName: aWorkspaceDimensionRow.WB_DimensionRow.cif.TECHNICAL_NAME,
                DimensionRenderOptions: JSONUtils.parse(aWorkspaceDimensionRow.WB_DimensionRow.cif.RENDER_OPTIONS, {}),
                SortOrder: aWorkspaceDimensionRow.WB_DimensionRow.cif.SORT_ORDER
            }
            try {
                let aDimensionHierarchyService = new DimensionDataService(aConnection, aDimension)
                let i = 0
                let defaultDims: string[] = []
                let hierarchies = await aDimensionHierarchyService.getHierarchies()
                hierarchies = _.filter(hierarchies, h => h.WBSalesOrgId == self.WB_Workspace.WB_SALESORG_ID)

                _.forEach(selectedKeys, (aClip) => {
                    if (!_.isEmpty(aClip) && aDimension.DimensionId in aClip) {
                        let aHierarchyId = aClip[aDimension.DimensionId].split(",")[0]
                        if ((aDimension.DimensionId in aClip) && i < 3) {
                            if (!_.includes(defaultDims, aHierarchyId) && !_.includes(_.map(hierarchies, 'HierarchyId'), aDimension.DimensionRenderOptions.defaultHierarchy)) {
                                aDimensionHierarchyService.getHierarchyNodes(aHierarchyId)
                                defaultDims.push(aHierarchyId)
                            }
                            if (i == 2)
                                return false
                            i++
                        }
                    }
                })
            } catch (e) {
                console.log(e)
            }
        }
        dimension = aWorkspaceDimensionRow.WB_DimensionRow.cif.DIMENSION_ID
        /*
        if (!_.isEmpty(clip)) {
            if (this.usrContext.hasRoleId(aWorkspaceDimensionRow.WB_DimensionRow.cif.VALUELINK_USER_ROLE_RQD)
                && aWorkspaceDimensionRow.WB_DimensionRow.cif.WB_DIMENSION_ID_VALUELINK > 0
                && !_.isEmpty(aWorkspaceDimensionRow.WB_DimensionRow.cif.VALUELINK_POLICY)) {
                let valueLink = _.first(_.filter(mainRow.WB_WorkspaceDimensionRows, aRow => aRow.cif.WB_DIMENSION_ID == aWorkspaceDimensionRow.WB_DimensionRow.cif.WB_DIMENSION_ID_VALUELINK))
                if (!_.isEmpty(valueLink)) {
                    if (aWorkspaceDimensionRow.WB_DimensionRow.cif.VALUELINK_POLICY == "all") {
                        dimension = valueLink.WB_DimensionRow.cif.DIMENSION_ID
                    }

                    if (aWorkspaceDimensionRow.WB_DimensionRow.cif.VALUELINK_POLICY == "crossWorkable" && valueLink.WB_DimensionRow.cif.DIMENSION_ID.toLowerCase().indexOf("product") >= 0) {
                        let defaultValues = _.isEmpty(clip[valueLink.WB_DimensionRow.cif.DIMENSION_ID]) ? [] : clip[valueLink.WB_DimensionRow.cif.DIMENSION_ID].split(",")
                        if (defaultValues.length) {
                            let aDefaultHierarchy: WB_ProductHierarchyRow = <WB_ProductHierarchyRow>_.first(await self.dbContext.findUsingCache(esWB_Product_Hierarchy, [defaultValues[0]]))
                            if (aDefaultHierarchy.cif.WB_PRDH_ID_CPPG > 0) {
                                dimension = valueLink.WB_DimensionRow.cif.DIMENSION_ID
                                bLinked=true
                            }
                        }
                    }
                }
            }
        }


        if (bLinked && !_.isEmpty(clip) && _.isEmpty(clip[dimension])) {
            clip = _.first(_.filter(selectedKeys, aClip => (dimension in aClip)))
        }
         */

        if (!_.isEmpty(clip) && !_.isEmpty(clip[dimension])) {
            let defaultValues = clip[dimension].split(",")
            aWorkspaceDimensionRow.cif.SELECTEDKEYS = _.isEmpty(defaultValues[1]) ? "" : defaultValues[1]
            aWorkspaceDimensionRow.cif.SELECTEDHIERARCHY = _.isEmpty(defaultValues[0]) ? "" : defaultValues[0]
        }

    }

    //</editor-fold>

    //<editor-fold desc = "IHaveDimensions operations">

    _OnDimensionsChanged: BehaviorSubject<IHaveDimensions>
    _bIHaveDimensionsLoaded: boolean
    _OnIHaveDimensionsLoadComplete: Promise<IHaveDimensions>

    IHaveDimensions_init(): void {
        this._bIHaveDimensionsLoaded = false
        this._OnDimensionsChanged = new BehaviorSubject<IHaveDimensions>(this);
        this._OnIHaveDimensionsLoadComplete = undefined
    }

    addDimension(WbDimensionId: number, options?: any): Promise<IHaveDimensions> {
        const self = this

        return new Promise<IHaveDimensions>((resolve, error) => {
            let found = false
            //   var aUsrCtx = <IUsrContext>PAEnvironment.getValue(PAEnvironment.UserContext)

            _.forEach(_.filter(self.Dimensions, aDim => aDim.cif.DELETED_IND != '1'), (aDimension: WB_DimensionRow) => {
                if (aDimension.cif.WB_DIMENSION_ID == WbDimensionId) {
                    found = true
                    return false  // stop iterating
                }
            })

            if (found) {
                resolve(self)
                return
            }

            let dmRow: WB_DimensionRow = undefined
            let wsDimRow: WB_WorkspaceDimensionRow = undefined

            self.dbContext.find(esWB_Dimension, WbDimensionId)
                .then((dimRecord: WB_DimensionRow) => {

                    dmRow = dimRecord
                    if (_.isEmpty(dimRecord)) {
                        // Dimension not found
                        error("Dimension not found: " + WbDimensionId)
                        return
                    }

                    return dmRow.loadRelations([esWB_Connection])

                }).then((ignore) => {

                return self.dbContext.createRecordWithKey(esWB_Workspace_Dimension)

            }).then((newRecord: WB_WorkspaceDimensionRow) => {

                wsDimRow = newRecord
                newRecord.setDefaults()
                newRecord.cif.WB_WORKSPACE_ID = self.WB_Workspace.cif.WB_WORKSPACE_ID
                //newRecord.WB_WorkspaceRow = self.WB_Workspace
                newRecord.cif.WB_DIMENSION_ID = dmRow.cif.WB_DIMENSION_ID
                newRecord.WB_DimensionRow = dmRow
                var opts = JSONUtils.parse(dmRow.cif.RENDER_OPTIONS, {})

                if ('defaultHierarchy' in opts) {
                    newRecord.cif.SELECTEDHIERARCHY = opts.defaultHierarchy;
                } else {
                    newRecord.cif.SELECTEDHIERARCHY = ''
                }

                wsDimRow.cif.SORT_ORDER = dmRow.cif.SORT_ORDER
                self.dbContext.add(esWB_Workspace_Dimension, wsDimRow)

                self.OnDimensionsChanged.next(self)
                resolve(self)
            }).catch((err) => {
                error(err)
            })
        })

    }

    removeDimension(WbDimensionId: number): Promise<IHaveDimensions> {
        const self = this

        return new Promise<IHaveDimensions>((resolve, error) => {
            let found = false
            _.forEach(self.WB_Workspace.WB_WorkspaceDimensionRows, (aWrksSpDimension: WB_WorkspaceDimensionRow) => {
                if (aWrksSpDimension.isActive && (aWrksSpDimension.WB_DimensionRow) && (aWrksSpDimension.WB_DimensionRow.cif.WB_DIMENSION_ID == WbDimensionId)) {
                    aWrksSpDimension.cif.DELETED_IND = '1'
                    aWrksSpDimension.markDeleted()
                    found = true
                }
            })

            if (found) {
                self.OnDimensionsChanged.next(self)
            }

            resolve(self)

        })

    }


    get OnIHaveDimensionsLoadComplete(): Promise<IHaveDimensions> {
        const self = this

        if (self.bIHaveDimensionsLoaded) {
            return ASync.resolve(self)
        }

        if (self._OnIHaveDimensionsLoadComplete != undefined) {
            return self._OnIHaveDimensionsLoadComplete
        }

        // Sync up missing dimensions.
        self._OnIHaveDimensionsLoadComplete = new Promise<IHaveDimensions>((resolve, error) => {

            self.dbContext.findAll(esWB_Dimension, {WORKSPACE_IND: '1', DELETED_IND: {neq: '1'}})
                .then((dimRows: WB_DimensionRow[]) => {
                    async function createMissingDimensions() {
                        for (var i = 0; i < dimRows.length; i++) {
                            let dimId = dimRows[i].cif.WB_DIMENSION_ID
                            await self.addDimension(dimId)
                        }
                    }

                    return createMissingDimensions()
                }).then((ignore) => {
                self._bIHaveDimensionsLoaded = true
                resolve(self);
            }).catch((err) => {
                error(err)
            })

        })

        return self._OnIHaveDimensionsLoadComplete
    }

    get bIHaveDimensionsLoaded(): boolean {
        return this._bIHaveDimensionsLoaded
    }

    get Dimensions(): WB_DimensionRow[] {
        let returnValue: WB_DimensionRow[] = []

        _.forEach(this.WB_Workspace.WB_WorkspaceDimensionRows, (aWrkspDimRow: WB_WorkspaceDimensionRow) => {
            if (aWrkspDimRow.isActive && aWrkspDimRow.WB_DimensionRow) {
                returnValue.push(aWrkspDimRow.WB_DimensionRow)
            }
        })

        return returnValue
    }

    get OnDimensionsChanged(): BehaviorSubject<IHaveDimensions> {
        return this._OnDimensionsChanged
    }

//</editor-fold>

    //<editor-fold desc = "IHaveWorkspaceReport operations">

    _OnWorkspaceReportsChanged: BehaviorSubject<IHaveWorkspaceReports>
    _bIHaveWorkspaceReportsLoaded: boolean
    _OnIHaveWorkspaceReportsLoadComplete: Promise<IHaveWorkspaceReports>

    IHaveWorkspaceReports_init(): void {
        this._bIHaveWorkspaceReportsLoaded = false
        this._OnWorkspaceReportsChanged = new BehaviorSubject<IHaveWorkspaceReports>(this);
        this._OnIHaveWorkspaceReportsLoadComplete = undefined
    }


    addWorkspaceReport(WbReportId: number, options?: any): Promise<IHaveWorkspaceReports> {
        const self = this

        return new Promise<IHaveWorkspaceReports>((resolve, error) => {

            let aRptRow: WB_ReportTileRow = undefined
            let aWrkSpRptRow: WB_WorkspaceReportRow = undefined

            self.dbContext.find(esWB_ReportTile, WbReportId)
                .then((rptRow) => {

                    if (_.isEmpty(rptRow)) {
                        error("Report not found")
                        return
                    }

                    aRptRow = rptRow
                    return aRptRow.loadRelations([esWB_Connection, esWB_ReportTile_Dimension])
                })
                .then((ignore) => {

                    return self.dbContext.createRecordWithKey(esWB_Workspace_Report)
                })
                .then((newRecord: WB_WorkspaceReportRow) => {
                    aWrkSpRptRow = newRecord
                    newRecord.setDefaults()
                    newRecord.cif.WB_WORKSPACE_ID = self.WB_Workspace.cif.WB_WORKSPACE_ID
                    newRecord.cif.WB_REPORTTILE_ID = aRptRow.cif.WB_REPORTTILE_ID
                    newRecord.WB_ReportRow = aRptRow
                    newRecord.cif.RENDER_OPTIONS = '{}'
                    self.dbContext.add(esWB_Workspace_Report, newRecord)
                })
                .then((ignore) => {
                    async function addReportDimensions(selectedKeys: any[]) {
                        let dims: WB_ReportTileDimensionRow[] = _.sortBy(_.filter(aRptRow.WB_ReportTileDimensionRows, aRow => aRow.isActive), 'SORT_ORDER', 'asc')
                        for (let i = 0; i < dims.length; i++) {
                            await self.addWorkspaceReportDimension(aWrkSpRptRow, dims[i], selectedKeys)
                        }
                    }

                    let selectedKeys = self.applicationSession.getMRUList()
                    return addReportDimensions(selectedKeys)
                })
                .then((ignore) => {
                    self.OnWorkspaceReportsChanged.next(self)
                    resolve()
                }).catch((err) => {
                error(err)
            })

        })
    }

    copyWorkspaceReport(WbWorkspaceReportId: number, options?: any): Promise<IHaveWorkspaceReports> {
        const self = this

        return new Promise<IHaveWorkspaceReports>((resolve, error) => {
            let srcWrkSpRptRow: WB_WorkspaceReportRow = undefined
            let newWrkSpRptRow: WB_WorkspaceReportRow = undefined

            ASync.resolve(self.dbContext.get(esWB_Workspace_Report, WbWorkspaceReportId))
                .then((aWrkspcRprtRow: WB_WorkspaceReportRow) => {
                    if (_.isEmpty(aWrkspcRprtRow)) {
                        error("Workspace Report not found")
                        return
                    }
                    srcWrkSpRptRow = aWrkspcRprtRow
                    return self.dbContext.createRecordWithKey(esWB_Workspace_Report)
                })
                .then((newRecord: WB_WorkspaceReportRow) => {
                    newWrkSpRptRow = newRecord
                    newRecord.setDefaults()
                    newRecord.cif.RENDER_OPTIONS = srcWrkSpRptRow.cif.RENDER_OPTIONS
                    newRecord.cif.WB_REPORTTILE_ID = srcWrkSpRptRow.cif.WB_REPORTTILE_ID
                    newRecord.cif.WB_WORKSPACE_ID = srcWrkSpRptRow.cif.WB_WORKSPACE_ID
                    newRecord.WB_ReportRow = srcWrkSpRptRow.WB_ReportRow
                    //newRecord.WB_WorkspaceReportDimensionRows = srcWrkSpRptRow.WB_WorkspaceReportDimensionRows
                    newRecord.WB_WorkspaceRow = srcWrkSpRptRow.WB_WorkspaceRow
                    self.dbContext.add(esWB_Workspace_Report, newRecord)
                    resolve()
                })
                .then((ignore) => {
                    async function copyReportDimensions() {
                        let dims: WB_WorkspaceReportDimensionRow[] = srcWrkSpRptRow.WB_WorkspaceReportDimensionRows
                        for (var i = 0; i < dims.length; i++) {
                            let aDimRow: WB_WorkspaceReportDimensionRow = dims[i]
                            await self.copyWorkspaceReportDimension(newWrkSpRptRow, aDimRow)
                        }
                    }

                    return copyReportDimensions()
                })
                .then((ignore) => {
                    self.OnWorkspaceReportsChanged.next(self)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    private async addWorkspaceReportDimension(aWorkspaceReportRow: WB_WorkspaceReportRow, aRptDimRow: WB_ReportTileDimensionRow, selectedKeys: any[]): Promise<void> {
        const self = this
        if (_.isEmpty(aWorkspaceReportRow)) {
            return
        }

        if (_.isEmpty(aRptDimRow) || !(aRptDimRow.cif.WB_DIMENSION_ID>0))
            return

        let aDimRow: WB_DimensionRow = await self.dbContext.find(esWB_Dimension, aRptDimRow.cif.WB_DIMENSION_ID, {with: {esWB_Connection}})
        let newRecord: WB_WorkspaceReportDimensionRow = <WB_WorkspaceReportDimensionRow>await self.dbContext.createRecordWithKey(esWB_Workspace_Report_Dimension)
        newRecord.setDefaults()
        newRecord.cif.WB_WORKSPACE_RPTL_ID = aWorkspaceReportRow.cif.WB_WORKSPACE_RPTL_ID
        newRecord.cif.WB_DIMENSION_ID = aDimRow.cif.WB_DIMENSION_ID
        newRecord.WB_DimensionRow = aDimRow
        newRecord.cif.SORT_ORDER = aRptDimRow.cif.SORT_ORDER
        newRecord.cif.LOCKED_IND = '0'
        await self._setDefaultHierarchy(self.WB_Workspace, newRecord, selectedKeys, false)
        self.dbContext.add(esWB_Workspace_Report_Dimension, newRecord)

    }

    private copyWorkspaceReportDimension(aWorkspaceReportRow: WB_WorkspaceReportRow, aDimRow: WB_WorkspaceReportDimensionRow, options?: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            if (_.isEmpty(aWorkspaceReportRow)) {
                resolve()
                return
            }

            self.dbContext.createRecordWithKey(esWB_Workspace_Report_Dimension)
                .then((newRecord: WB_WorkspaceReportDimensionRow) => {
                    newRecord.setDefaults()
                    newRecord.cif.WB_WORKSPACE_RPTL_ID = aWorkspaceReportRow.cif.WB_WORKSPACE_RPTL_ID
                    newRecord.cif.WB_DIMENSION_ID = aDimRow.cif.WB_DIMENSION_ID
                    newRecord.WB_DimensionRow = aDimRow.WB_DimensionRow
                    newRecord.cif.SORT_ORDER = aDimRow.cif.SORT_ORDER
                    newRecord.cif.LOCKED_IND = aDimRow.cif.LOCKED_IND
                    newRecord.cif.SELECTEDHIERARCHY = aDimRow.cif.SELECTEDHIERARCHY
                    newRecord.cif.SELECTEDKEYS = aDimRow.cif.SELECTEDKEYS

                    self.dbContext.add(esWB_Workspace_Report_Dimension, newRecord)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeWorkspaceReport(WbWorkspaceReportId: number): Promise<IHaveWorkspaceReports> {
        const self = this

        return new Promise<IHaveWorkspaceReports>((resolve, error) => {
            let found = false
            _.forEach(self.WB_Workspace.WB_WorkspaceReportRows, (aWrksSpReport: WB_WorkspaceReportRow) => {
                if (aWrksSpReport.isActive && (aWrksSpReport.cif.WB_WORKSPACE_RPTL_ID == WbWorkspaceReportId)) {
                    aWrksSpReport.cif.DELETED_IND = '1'
                    aWrksSpReport.markDeleted()

                    _.forEach(aWrksSpReport.WB_WorkspaceReportDimensionRows, (aRptDimRow: WB_WorkspaceReportDimensionRow) => {
                        aRptDimRow.cif.DELETED_IND = '1'
                        aRptDimRow.markDeleted()
                    })
                    found = true
                }
            })

            if (found) {
                self.OnWorkspaceReportsChanged.next(self)
            }

            resolve(self)

        })
    }


    get OnIHaveWorkspaceReportsLoadComplete(): Promise<IHaveWorkspaceReports> {
        const self = this

        //   if (self.bIHaveDimensionsLoaded) {
        //       return ASync.resolve(self)
        //   }

        if (self._OnIHaveWorkspaceReportsLoadComplete != undefined) {
            return self._OnIHaveWorkspaceReportsLoadComplete
        }

// Sync up missing dimensions.
        this._OnIHaveWorkspaceReportsLoadComplete = new Promise<IHaveWorkspaceReports>((resolve, error) => {

            ASync.resolve()
                .then((ignore) => {

                    async function createMissingReportDimensions() {

                    }

                    return createMissingReportDimensions()

                }).then((ignore) => {
                resolve(self);
            }).catch((err) => {
                error(err)
            })

        })

    }


    get bIHaveWorkspaceReportsLoaded(): boolean {
        return this._bIHaveWorkspaceReportsLoaded
    }

    get WorkspaceReports(): WB_WorkspaceReportRow[] {
        return _.filter(this.WB_Workspace.WB_WorkspaceReportRows, aRow => aRow.isActive)
    }

    get OnWorkspaceReportsChanged(): BehaviorSubject<IHaveWorkspaceReports> {
        return this._OnWorkspaceReportsChanged
    }


//</editor-fold>

//<editor-fold desc = "IDimensionSelectorSet operations">
    private _bIDimensionSelectorSetLoaded: boolean
    private _dimensionSelectors: IDimensionSelector[]

    IDimensionSelector_init() {
        this._dimensionSelectors = []
        this._bIDimensionSelectorSetLoaded = false
    }

    get DimensionSelectors(): IDimensionSelector[] {
        return this._dimensionSelectors
    }

    get OnIDimensionSelectorSetLoadComplete(): Promise<IDimensionSelectorSet> {
        const self = this
        if (this.bIDimensionSelectorSetLoaded) {
            return ASync.resolve(this)
        }

        return new Promise<IDimensionSelectorSet>((resolve, error) => {

            self.OnIHaveDimensionsLoadComplete
                .then((ignore) => {
                    return self.OnIDimensionsSelector_DimensionsChanged()
                })
                .then(() => {
                    return self.WorkspaceElements_onWorkspaceReportsChanged(self)
                })
                .then(() => {
                    self._bIDimensionSelectorSetLoaded = true
                    resolve()
                })
                .catch((err: any) => {
                    error(err)
                })

        })
    }

    get bIDimensionSelectorSetLoaded(): boolean {
        return this._bIDimensionSelectorSetLoaded
    }

    private async OnIDimensionsSelector_DimensionsChanged(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            //
            let dctById = _.keyBy(self._dimensionSelectors, (aDimensionSelector: IDimensionSelector) => {
                return aDimensionSelector.Dimension.DimensionId
            })
            _.forEach(self.WB_Workspace.WB_WorkspaceDimensionRows, async (aWorkspaceDimensionRow: WB_WorkspaceDimensionRow) => {
                if (aWorkspaceDimensionRow.cif.DELETED_IND == '1') {
                    // remove if exists..
                    return
                }
                if (aWorkspaceDimensionRow.WB_DimensionRow.cif.DIMENSION_ID in dctById) {
                    return
                }
                self._dimensionSelectors.push(new WorkspaceBOIDimensionSelector(self, aWorkspaceDimensionRow))

            })

            resolve()
        })
    }

    private IDimensionSelectorSet_BeforeSave() {
        _.forEach(this.DimensionSelectors, (aSelector: WorkspaceBOIDimensionSelector) => {
            aSelector.saveSelections()
        })
    }


//</editor-fold>

//<editor-fold desc = "IWorkspaceElementSet operations">

    private _dctWorkspaceElements: { [id: string]: IWorkspaceElement }
    private _OnWorkspaceElementsChanged: BehaviorSubject<IWorkspaceElementSet>
    private _MessageBus: BehaviorSubject<IWorkspaceElementPost>;
    private _dctWorkspaceElementSub: { [id: string]: Subscription }


    private IWorkspaceElementSet_init() {
        const self = this
        self._dctWorkspaceElements = {}
        self._dctWorkspaceElementSub = {}
        self._OnWorkspaceElementsChanged = new BehaviorSubject<IWorkspaceElementSet>(self)
        self._MessageBus = new BehaviorSubject<IWorkspaceElementPost>(undefined)
        this.OnWorkspaceReportsChanged.subscribe(self.WorkspaceElements_onWorkspaceReportsChanged.bind(self));
    }

    get WorkspaceElements(): IWorkspaceElement[] {
        const self = this
        return _.values(this._dctWorkspaceElements)
    }

    get OnWorkspaceElementsChanged(): BehaviorSubject<IWorkspaceElementSet> {
        return this._OnWorkspaceElementsChanged
    }

    addWorkspaceElement(anElement: IWorkspaceElement): void {
        const self = this
        //
        let key = self.getWorkspaceElementKey(anElement.ElementId, anElement.ElementTypeId)
        self._dctWorkspaceElements[key] = anElement

// Listen to workspaceElement's
        self._dctWorkspaceElementSub[key] = anElement.OnOutboxMessage.subscribe(self.WorkspaceElement_onOutBoxMessageReceived.bind(self))

        self._OnWorkspaceElementsChanged.next(this)
    }

    private WorkspaceElement_onOutBoxMessageReceived(aPost: IWorkspaceElementPost): void {
        const self = this

        if (_.isEmpty(aPost)) {
            return
        }

// Iterate over element set and broadcast message to other element sets.
        _.forEach(self.WorkspaceElements, (aWorkspaceElement: IWorkspaceElement) => {
            if (aWorkspaceElement != aPost.WorkspaceElement) {
                aWorkspaceElement.PostInboxMessage(aPost.Message)
            }
        })

//
        self._MessageBus.next(aPost)

    }

    removeWorkspaceElement(aWorkspaceElementId: string | number, TypeId: string): void {
        const self = this
        let key = self.getWorkspaceElementKey(aWorkspaceElementId, TypeId)
        if (key in self._dctWorkspaceElements) {
            delete self._dctWorkspaceElements[key]
        }

        if (key in self._dctWorkspaceElementSub) {
            let sub: Subscription = self._dctWorkspaceElementSub[key]
            if (sub) {
                sub.unsubscribe()
            }
            delete self._dctWorkspaceElementSub[key]
        }

        this._OnWorkspaceElementsChanged.next(self)
    }

    containsWorkspaceElement(aWorkspaceElementId: string | number, TypeId: string): boolean {
        const self = this
        let key = self.getWorkspaceElementKey(aWorkspaceElementId, TypeId)
        return (key in self._dctWorkspaceElements)

    }

    get MessageBus(): BehaviorSubject<IWorkspaceElementPost> {
        return this._MessageBus
    }

    PostMessage(aMessage: IWorkspaceElementMessage): void {
        const self = this

        // For Each elementSet,post to inbox.. post to MessageBus.
        _.forEach(self.WorkspaceElements, (aWSElement: IWorkspaceElement) => {
            aWSElement.PostInboxMessage(aMessage)
        })

        self._MessageBus.next({WorkspaceElement: undefined, Message: aMessage})


    }


    private getWorkspaceElementKey(aWorkspaceElementId: string | number, TypeId: string): string {
        return aWorkspaceElementId + '-' + TypeId
    }

    private async WorkspaceElements_onWorkspaceReportsChanged(a: IHaveWorkspaceReports): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            if (_.isEmpty(self.WB_Workspace)) {
                return
            }
            _.forEach(self.WB_Workspace.WB_WorkspaceReportRows, async (aRow: WB_WorkspaceReportRow) => {
                //
                if (aRow.cif.DELETED_IND == '1') {
                    if (self.containsWorkspaceElement(aRow.cif.WB_WORKSPACE_RPTL_ID, aRow.WB_ReportRow.cif.REPORT_TYPE_ID)) {
                        self.removeWorkspaceElement(aRow.cif.WB_WORKSPACE_RPTL_ID, aRow.WB_ReportRow.cif.REPORT_TYPE_ID)
                    }
                    return
                }

                // If it's missing, add it
                if (!self.containsWorkspaceElement(aRow.cif.WB_WORKSPACE_RPTL_ID, aRow.WB_ReportRow.cif.REPORT_TYPE_ID)) {
                    let aWorkspaceReport = await new WorkspaceBOIWorkspaceReport(self, aRow)
                    self.addWorkspaceElement(aWorkspaceReport)

                }
            })
            resolve()
        })
    }

    private IWorkspaceElements_BeforeSave() {
        const self = this
        _.forEach(self._dctWorkspaceElements, (aWSE: IWorkspaceElement, key: string) => {

            // Moved to Save
            //if('saveState' in aWSE){
            //  let aWSR: WorkspaceBOIWorkspaceReport = <any> aWSE
            //  aWSR.saveState()
            //}

            aWSE.PostInboxMessage({SAVE: true})
        })
    }

//</editor-fold>

//<editor-fold desc = "IRecordResolverProvider   <<STATIC>> operations">

    Copy(options?: any): Promise<IBusinessObject> {
        const self: WorkspaceBO = this;
        return new Promise<IBusinessObject>((resolve, error) => {
            let newWorkspaceBO = new WorkspaceBO({dbContext: self.dbContext, bEagerLoadAspectInterfaces: true});
            newWorkspaceBO.LoadNew({
                dbContext: self.dbContext
            }).then((newWorkspaceBO: WorkspaceBO) => {
                async function copySequential() {
                    let newRecord = newWorkspaceBO.WB_Workspace;
                    newRecord.cif.RENDER_OPTIONS = self.WB_Workspace.cif.RENDER_OPTIONS;
                    newRecord.cif.TREE_PATH = self.WB_Workspace.cif.TREE_PATH;
                    newRecord.cif.WORKSPACE_TYPE_ID = self.WB_Workspace.cif.WORKSPACE_TYPE_ID;
                    newRecord.cif.WORKSPACE_NAME = self.drWB_Workspace.cif.WORKSPACE_NAME + " - Copy";

                    //add workspace Report
                    for (let idx = 0; idx < self.WB_Workspace.WB_WorkspaceReportRows.length; idx++) {
                        let workspaceReportRow = <WB_WorkspaceReportRow>self.WB_Workspace.WB_WorkspaceReportRows[idx];
                        await newWorkspaceBO.addWorkspaceReport(workspaceReportRow.cif.WB_REPORTTILE_ID);
                    }
                }

                if (newWorkspaceBO.bIsLoaded) {
                    return copySequential()
                } else {
                    console.log('Workspace BO creation failed')
                    error('Workspace BO creation failed')
                }
            }).then(() => {
                resolve(newWorkspaceBO)
            })
                .catch((err) => {
                    console.log('Workspace BO creation failed:')
                    console.log(err);
                    error(err)
                })
        })
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {
                [esWB_ReportTile]: [esWB_Connection, esWB_ReportTile_Dimension],
                [esWB_Dimension]: [esWB_Connection],
                [esWB_ReportTile_Dimension]: [esWB_Dimension]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Workspace, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

//</editor-fold>


};
PAEnvironment.registerBusinessObjectClass(WorkspaceBO, "WorkspaceBO", "Workspace")